export default __webpack_public_path__ + "static/media/07.f5dc5e6f.jpg";